var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
/**
 * Express the section you want to brag about using Image component.
 *
 * @props src: Image source url. (default: {@link https://picsum.photos/300/300/?random})
 * @props subhead: Sub title text.	(default: 'Write your subhead')
 * @props subheadSize: subhead text size style. (default: '14px')
 * @props subheadColor: subhead text color size style. (default: 'black')
 * @props head: Main title text.	(default: 'Write your head')
 * @props headSize: head text size style. (default: '20px')
 * @props headWeight: head text weight style. (default: '700')
 * @props headColor: head color style. (default: 'black')
 * @props redirectURL: URL you want to redirect when clicked. (default: '/')
 * @props noShowHead: If this value is set to True, you can hide the head text. (default: false)
 * @props zoomWhenHover: If this value is set to True, you can zoom image when hovered on image. (default: true)
 */
var Image = function (_a) {
    var src = _a.src, subhead = _a.subhead, subheadSize = _a.subheadSize, subheadColor = _a.subheadColor, head = _a.head, headSize = _a.headSize, headWeight = _a.headWeight, headColor = _a.headColor, redirectURL = _a.redirectURL, noShowHead = _a.noShowHead, zoomWhenHover = _a.zoomWhenHover;
    return (_jsx(Wrap, { children: _jsx(Items, __assign({ subheadSize: subheadSize, subheadColor: subheadColor, headSize: headSize, headWeight: headWeight, headColor: headColor, noShowHead: noShowHead, zoomWhenHover: zoomWhenHover }, { children: _jsxs("a", __assign({ href: redirectURL }, { children: [_jsx("div", __assign({ className: "imgWrap" }, { children: _jsx("img", { src: src }) })), _jsxs("div", __assign({ className: "imgDes" }, { children: [_jsx("p", __assign({ className: "subhead" }, { children: subhead })), _jsx("div", __assign({ className: "head" }, { children: head }))] }))] })) })) }));
};
export default Image;
Image.defaultProps = {
    src: 'https://picsum.photos/300/300/?random',
    subhead: 'Write your subhead',
    subheadSize: '14px',
    subheadColor: 'black',
    head: 'Write your head',
    headSize: '20px',
    headWeight: '700',
    headColor: 'black',
    redirectURL: '/',
    noShowHead: false,
    zoomWhenHover: true,
};
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  display: inline;\n  color: red;\n"], ["\n  display: flex;\n  justify-content: center;\n  display: inline;\n  color: red;\n"])));
var Items = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n  margin-bottom: ", ";\n  a {\n    text-decoration-line: none;\n\n    .imgWrap {\n      overflow: hidden;\n    }\n    img {\n      width: 100%;\n      transition: 0.6s;\n      object-fit: cover;\n      display: block;\n      :hover {\n        transform: ", ";\n      }\n    }\n    .imgDes {\n      display: ", ";\n      .subhead {\n        margin: 5px 0px 1px 1px;\n        font-size: ", ";\n        color: ", ";\n        @media screen and (max-width: 800px) {\n          font-size: 1rem;\n        }\n      }\n      .head {\n        font-size: ", ";\n        font-weight: ", ";\n        color: ", ";\n        @media screen and (max-width: 800px) {\n          font-size: 1.2rem;\n        }\n      }\n      margin-bottom: 10px;\n    }\n  }\n"], ["\n  display: inline-block;\n  width: 100%;\n  margin-bottom: ", ";\n  a {\n    text-decoration-line: none;\n\n    .imgWrap {\n      overflow: hidden;\n    }\n    img {\n      width: 100%;\n      transition: 0.6s;\n      object-fit: cover;\n      display: block;\n      :hover {\n        transform: ", ";\n      }\n    }\n    .imgDes {\n      display: ", ";\n      .subhead {\n        margin: 5px 0px 1px 1px;\n        font-size: ", ";\n        color: ", ";\n        @media screen and (max-width: 800px) {\n          font-size: 1rem;\n        }\n      }\n      .head {\n        font-size: ", ";\n        font-weight: ", ";\n        color: ", ";\n        @media screen and (max-width: 800px) {\n          font-size: 1.2rem;\n        }\n      }\n      margin-bottom: 10px;\n    }\n  }\n"])), function (_a) {
    var noShowHead = _a.noShowHead;
    return (noShowHead ? 0 : '1.2em');
}, function (_a) {
    var zoomWhenHover = _a.zoomWhenHover;
    return (zoomWhenHover ? 'scale(105%)' : 'none');
}, function (_a) {
    var noShowHead = _a.noShowHead;
    return (noShowHead ? 'none' : 'inline');
}, function (_a) {
    var subheadSize = _a.subheadSize;
    return subheadSize;
}, function (_a) {
    var subheadColor = _a.subheadColor;
    return subheadColor;
}, function (_a) {
    var headSize = _a.headSize;
    return headSize;
}, function (_a) {
    var headWeight = _a.headWeight;
    return headWeight;
}, function (_a) {
    var headColor = _a.headColor;
    return headColor;
});
var templateObject_1, templateObject_2;
